import { Injectable, inject } from '@angular/core';
import { BaseComponent } from '../../app/components/base/base.component';
import { DialogService, NotificationService } from '../services';
import { DeploymentApiService } from './deployment-api/deployment-api.service';
import { get, includes } from 'lodash-es';
import { CodeInspectService } from '../bottom-left-menu/services/code-inspect-service';
import { showMsg } from '@wms/app/vcs/utils/vcs-utils';
import { VcsService } from '../vcs/services/vcs.service';
import { VcsAPIService } from '../vcs/services/vcs-api/vcs-api.service';
import { WmsWorkspaceManagerService } from "@wms/workspace";
import {addResizableClass, removeResizableClass} from "@wms/core";

@Injectable({
  providedIn: 'root'
})
export class DeploymentService extends BaseComponent {
  public setupInfo: any
  private dialogService: DialogService;
  private deploymentApi: DeploymentApiService
  private notificationService: NotificationService;
  private codeInspectorService: CodeInspectService
  private vcsService: VcsService
  private vcsApiService: VcsAPIService
  private wsManager: WmsWorkspaceManagerService;
  private pipelineInfo: any
  public deploySetupDone: boolean
  public deployedAppUrl: string
  public checkingDeployStatus: boolean = false
  private deployActivityState: any
  private deployStatusTimeout: any
  public manageAppUrl: string
  public deployInProgress: boolean
  public showManageAppBtn: boolean = true
  public provisioningPromise: any

  public INSP_RUN = 0;
  public INSP_WARN = 1;
  public INSP_ERR = 2;
  public INSP_SUCC = 3;

  public inspectionState: number;

  private deployProgressSteps = [
    "PROVISIONING_ENVIRONMENT",
    "INSERTING_TO_PROCESSING_QUEUE",
    "FETCH_FROM_PROCESSING_QUEUE",
    "PULLING_CODE_FROM_VCS",
    "PREPARE_BUILD",
    "PREPARE_WAR_UPDATE",
    "DEPLOY_APPLICATION"
  ]
  provisioning: any;
  deployFinished: boolean;
  currentDeployStep: number | null;
  deploying: any;
  msgData = { type: '', show: false, caption: '' };

  constructor() {
    super()
    this.dialogService = inject(DialogService)
    this.deploymentApi = inject(DeploymentApiService)
    this.notificationService = inject(NotificationService)
    this.codeInspectorService = inject(CodeInspectService)
    this.vcsService = inject(VcsService)
    this.vcsApiService = inject(VcsAPIService)
    this.wsManager = inject(WmsWorkspaceManagerService)
  }

  getSetupInfo() {
    this.deploymentApi.getSetupInfo()
      .then((response) => {
        this.setupInfo = response
        this.getFirstPhaseInfo()
      })
      .catch(errorMsg => {
        this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, errorMsg)
      })
  }

  getFirstPhaseInfo() {
    this.deploymentApi.getFirstPhaseInfo()
      .then(response => {
        if (response) {
          this.pipelineInfo = response
          this.deploySetupDone = (response?.appPipelinePhase) ? true : false;
          this.deployedAppUrl = this.deploySetupDone ? response.appPipelinePhase.appUrl : ''
        } else {
          this.deploySetupDone = false;
        }
        this.beginDeployStatusCheck(true)
      })
      .catch(error => {
        this.deploySetupDone = false
        this.markDeploymentAsFinished()
      })
  }

  beginDeployStatusCheck(isLoaded: boolean) {
    this.deployActivityState = {}
    if (isLoaded && this.pipelineInfo) {
      this.checkingDeployStatus = true;
      this.deploymentApi.getSetupInfo()
        .then(() => {
          this.pollDeployStatus();
        })
        .catch(errMsg => {
          this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, errMsg);
        });
    }
    else if (isLoaded) {
      this.markDeploymentAsFinished()
    }
  }

  setDeployStateToInprogress() {
    this.deployInProgress = true;
  }

  markDeploymentAsFinished(successFlag? : boolean, msg?: string) {
    this.checkingDeployStatus = false;
    clearInterval(this.deployStatusTimeout)
    this.showManageAppBtn = true
    this.deployFinished = true;
    this.currentDeployStep = this.getCurrentDeployStep();
    if (successFlag === true) {
      this.deploying = {
        'success': true
      };
      this.msgData = showMsg(this.locale.LABEL_DEPLOY_PROGRESS_FOURTH, "success")
      this.deployInProgress && this.notificationService.show("success", "Deployment Success", msg || this.locale.LABEL_DEPLOY_DEF_ERR_MSG)

    } else if (successFlag === false) {
      this.deploying = {
        'error': true
      };
      this.msgData = showMsg(this.locale.LABEL_DEPLOY_FAILED, "error")
      this.deployInProgress && this.notificationService.show("error", this.locale.LABEL_DEPLOY_FAILED, msg || this.locale.LABEL_DEPLOY_DEF_ERR_MSG)
    }
    this.deployInProgress = this.deployInProgress && false
  }

  pollDeployStatus(params?: any, pipelinePhaseParams?: any) {
    this.deployStatusTimeout = setInterval(() => {
      this.deployPolling(params, pipelinePhaseParams)
    }, 10000)
  }

  deployPolling(params: any, pipelinePhaseParams: any) {
    params = params || {};
    if (!pipelinePhaseParams && this.pipelineInfo) {
      pipelinePhaseParams = {
        "pipelinePhaseId": this.pipelineInfo.appPipelinePhase.pipelinePhaseId
      }
    }
    this.deploymentApi.pullDeployStatus(params, pipelinePhaseParams)
      .then((deployPollResponse) => {
        if (!deployPollResponse) {
          this.markDeploymentAsFinished(false)
          return;
        } else {
          const deployPollStatus = deployPollResponse.appState
          this.deployActivityState = deployPollResponse.activityProgress || {}
          this.manageAppUrl = "/deployed-apps/app/main.html#/app/" + this.projectService.getProjectEdnDetails().id
          if (deployPollStatus === "FAILED") {
            this.markDeploymentAsFinished(false)
          } else if (deployPollStatus === "DEPLOYED") {
            this.deploymentApi.getFirstPhaseInfo()
              .then(response => {
                if (response) {
                  this.pipelineInfo = response;
                  this.deploySetupDone = (response.appPipelinePhase) ? true : false;
                  this.deployedAppUrl = response.appPipelinePhase.appUrl;
                } else {
                  this.deploySetupDone = false;
                }
              })
              .catch(() => {
                this.deploySetupDone = false;
              });
            this.markDeploymentAsFinished(true)
          } else if (deployPollStatus === "DEPLOYING") {
            if (!this.deployInProgress) {
              this.setDeployStateToInprogress()
            }
          }
        }
      })
      .catch(() => {
        this.markDeploymentAsFinished(false)
      })
  }

  deployToCloud() {
    this.wsManager.triggerSaveImmediately = true;
    this.wsManager.saveActiveWs.next(() => {
      this.checkingDeployStatus = true;
      this.deployToCSCloud();
    })
  }

  deployToCSCloud() {
    this.markDeploymentAsFinished()
    this.vcsApiService.validateNoChanges().then(() => {
      this.triggerDeployment()
    }, (error) => {
      if(error && error.status === 400 && error.error.errors.error[0].messageKey === "com.wavemaker.vcs$haveUnPushedChanges") {
        if(this.projectService.teamProjectObject.vcsAccountDTO.mrFlowEnabled) {
          this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], this.locale.MSG_ERROR_UNPUSHED_CHANGES);
        } else {
          this.vcsService.vcsAction = 'push'
          this.vcsService.openDialogWithId('vcsSyncDialog');
        }
      }
      if(error && error.status === 400 && error.error.errors.error[0].messageKey === "com.wavemaker.vcs$unMergedChanges") {
        this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], this.locale.MSG_ERROR_UNMERGED_CHANGES);
      }
    });
  }

  triggerDeployment() {
    this.deployInProgress = true
    this.resetDialogState()
    this.openDialogWithId("deployDialog")
    this.runInspection()
    this.pollCurrentDeployStep()
  }

  resetDialogState() {
    this.provisioning = {
      'loading': true
    };
    this.deploying = null
    this.deployFinished = false
    this.inspectionState = this.INSP_RUN
    this.currentDeployStep = null
    this.deployActivityState = {}
    this.showManageAppBtn = false;
    this.closeInspectErrors()
    this.msgData = showMsg(this.locale.LABEL_DEPLOY_NOTIFICATION, "loading")
  }

  pollCurrentDeployStep() {
    this.provisioningPromise = setInterval(() => {
      this.currentDeployStep = this.getCurrentDeployStep();
    }, 3000);
  }

  getCurrentStep() {
    return this.currentDeployStep as number
  }

  runInspection() {
    this.codeInspectorService.refreshInspect().then((response: any) => {
      if (response?.results && response?.results?.length) {
        if (response.errorCount) {
          this.inspectionState = this.INSP_ERR;
        }
        else if (response.warningCount) {
          this.inspectionState = this.INSP_WARN;
        }
      } else if (response?.data && response?.data?.error) {
        this.inspectionState = this.INSP_ERR;
      } else {
        this.inspectionState = this.INSP_SUCC;
      }

      /*--- If pipeline phase is not configured then configure it first and then deploy otherwise deploy it -----*/
      if (this.inspectionState === this.INSP_ERR || this.inspectionState === this.INSP_SUCC || this.inspectionState === this.INSP_WARN) {
        this.eventManager.emitRefreshInspect();
        if (!this.pipelineInfo || get(this.pipelineInfo, 'pipelineTemplatePhase.orderId') !== 0) {
          this.configureAndDeploy();
        } else {
          this.csDeploy({
            "pipelinePhaseId": this.pipelineInfo.appPipelinePhase.pipelinePhaseId
          });
        }
      }
    })
  }

  checkDeployStatus() {
    this.provisioning = {
      'loading': true
    };
    this.msgData = showMsg(this.locale.LABEL_DEPLOY_NOTIFICATION, "loading")
    this.openDialogWithId("deployDialog")
    this.pollCurrentDeployStep()
  }

  configureAndDeploy() {
    const configureParams = {
      "projectId": this.projectService.getProjectEdnDetails().id,
      "wmCloudProviderVO": {
        "cloudProvider": "WM_CLOUD"
      }
    }

    this.deploymentApi.configureAndDeploy(configureParams)
      .then((response) => {
        const pipelinePhaseParams = {
          "pipelinePhaseId": response.pipelinePhaseId
        };
        this.deploySetupDone = true;
        this.eventManager.emitJobStatus('');
        this.pollDeployStatus({}, pipelinePhaseParams);
      })
      .catch((errorObj: any) => {
        this.markDeploymentAsFinished(false, get(errorObj, 'error.errors.error[0].message') || '')
      })
  };

  csDeploy(pipelinePhaseParams: any) {
    const deployParams = {
      buildProfile: 'deployment'
    };

    if (this.pipelineInfo?.appDeployment?.buildProfileName && includes(['deployment', 'development', 'production'], this.pipelineInfo.appDeployment.buildProfileName)) {
      deployParams.buildProfile = "deployment";
    } else if (this.pipelineInfo?.appDeployment?.buildProfileName && get(this.pipelineInfo, 'pipelineTemplatePhase.orderId') === 0) {
      deployParams.buildProfile = this.pipelineInfo.appDeployment.buildProfileName;
    }

    this.deploymentApi.deployFirstPhase(deployParams, pipelinePhaseParams)
      .then((deployResponse) => {
        this.eventManager.emitJobStatus('');
        this.pollDeployStatus({}, pipelinePhaseParams);
      })
      .catch(() => {
        this.markDeploymentAsFinished(false)
      })
  }

  reDeployToCloud() {
    this.wsManager.triggerSaveImmediately = true;
    this.wsManager.saveActiveWs.next(() => {
      this.checkingDeployStatus = true;
      this.redeployToCSCloud();
    })
  }

  redeployToCSCloud() {
    let cloudProvider = get(this.pipelineInfo, 'appPipelinePhase.cloudProviderVO.cloudProvider');
    const cloudProvidersMap: any = {
        'AWS': 'AWS',
        'AZURE': 'Azure',
        'GOOGLE_CLOUD': 'GoogleCloud',
        'WM_CLOUD': 'WMCloud'
    };
    if (get(this.pipelineInfo, 'pipelineTemplatePhase.orderId') === 0) {
      this.deployToCSCloud();
    } else {
      const dialogParams ={
        title: (cloudProvidersMap[cloudProvider]?(cloudProvidersMap[cloudProvider] + ' '):(''))+ this.locale.LABEL_DEPLOYMENTS,
      }
      this.dialogService.open('app-confirm-dialog', dialogParams)
    }
  }


  getCurrentDeployStep() {
    return (this.deployActivityState && this.deployActivityState.activitySource)
      ? ((this.deployActivityState.activityState === 'COMPLETED')
        ? this.deployProgressSteps.indexOf(this.deployActivityState.activitySource) + 1
        : this.deployProgressSteps.indexOf(this.deployActivityState.activitySource))
      : 0;
  }

  checkInspectErrors() {
    this.eventManager.emitopenAppIssuesTab('wms-issues-tab');
    this.closeDeployDialog();
  }

  showInspectErrors() {
    this.codeInspectorService.isInspectCodeEnabled = true;
    addResizableClass('wm-studio-content-inspect-errors')
  };

  closeInspectErrors() {
    this.codeInspectorService.isInspectCodeEnabled = false;
    removeResizableClass('wm-studio-content-inspect-errors');
  };

  closeDeployDialog() {
    clearInterval(this.provisioningPromise)
    this.closeDialogWithId('deployDialog')
  }

  closeDialogWithId(id: string): void {
    this.dialogService.close(id);
  }
  openDialogWithId(id: string): void {
    this.dialogService.open(id);
  }
}

